import NotificationArea from './NotificationArea';

export default NotificationArea;
